import InvoiceAnalytics from "../../views/InvoiceAnalytics";

const InvoiceAnalyticsDashboardPage = () => <InvoiceAnalytics />;

export default InvoiceAnalyticsDashboardPage;
